function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/deletecommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import count from '@ckeditor/ckeditor5-utils/src/count';
import ChangeBuffer from './utils/changebuffer';
/**
 * The delete command. Used by the {@link module:typing/delete~Delete delete feature} to handle the <kbd>Delete</kbd> and
 * <kbd>Backspace</kbd> keys.
 *
 * @extends module:core/command~Command
 */

var DeleteCommand = /*#__PURE__*/function (_Command) {
  _inherits(DeleteCommand, _Command);

  var _super = _createSuper(DeleteCommand);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor
   * @param {'forward'|'backward'} direction The directionality of the delete describing in what direction it
   * should consume the content when the selection is collapsed.
   */
  function DeleteCommand(editor, direction) {
    var _this;

    _classCallCheck(this, DeleteCommand);

    _this = _super.call(this, editor);
    /**
     * The directionality of the delete describing in what direction it should
     * consume the content when the selection is collapsed.
     *
     * @readonly
     * @member {'forward'|'backward'} #direction
     */

    _this.direction = direction;
    /**
     * Delete's change buffer used to group subsequent changes into batches.
     *
     * @readonly
     * @private
     * @type {module:typing/utils/changebuffer~ChangeBuffer}
     */

    _this._buffer = new ChangeBuffer(editor.model, editor.config.get('typing.undoStep'));
    return _this;
  }
  /**
   * The current change buffer.
   *
   * @type {module:typing/utils/changebuffer~ChangeBuffer}
   */


  _createClass(DeleteCommand, [{
    key: "buffer",
    get: function get() {
      return this._buffer;
    }
    /**
     * Executes the delete command. Depending on whether the selection is collapsed or not, deletes its content
     * or a piece of content in the {@link #direction defined direction}.
     *
     * @fires execute
     * @param {Object} [options] The command options.
     * @param {'character'} [options.unit='character'] See {@link module:engine/model/utils/modifyselection~modifySelection}'s options.
     * @param {Number} [options.sequence=1] A number describing which subsequent delete event it is without the key being released.
     * See the {@link module:engine/view/document~Document#event:delete} event data.
     * @param {module:engine/model/selection~Selection} [options.selection] Selection to remove. If not set, current model selection
     * will be used.
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var doc = model.document;
      model.enqueueChange(this._buffer.batch, function (writer) {
        _this2._buffer.lock();

        var selection = writer.createSelection(options.selection || doc.selection);
        var sequence = options.sequence || 1; // Do not replace the whole selected content if selection was collapsed.
        // This prevents such situation:
        //
        // <h1></h1><p>[]</p>	-->  <h1>[</h1><p>]</p> 		-->  <p></p>
        // starting content		-->   after `modifySelection`	-->  after `deleteContent`.

        var doNotResetEntireContent = selection.isCollapsed; // Try to extend the selection in the specified direction.

        if (selection.isCollapsed) {
          model.modifySelection(selection, {
            direction: _this2.direction,
            unit: options.unit
          });
        } // Check if deleting in an empty editor. See #61.


        if (_this2._shouldEntireContentBeReplacedWithParagraph(sequence)) {
          _this2._replaceEntireContentWithParagraph(writer);

          return;
        } // Check if deleting in the first empty block.
        // See https://github.com/ckeditor/ckeditor5/issues/8137.


        if (_this2._shouldReplaceFirstBlockWithParagraph(selection, sequence)) {
          _this2.editor.execute('paragraph', {
            selection: selection
          });

          return;
        } // If selection is still collapsed, then there's nothing to delete.


        if (selection.isCollapsed) {
          return;
        }

        var changeCount = 0;
        selection.getFirstRange().getMinimalFlatRanges().forEach(function (range) {
          changeCount += count(range.getWalker({
            singleCharacters: true,
            ignoreElementEnd: true,
            shallow: true
          }));
        });
        model.deleteContent(selection, {
          doNotResetEntireContent: doNotResetEntireContent,
          direction: _this2.direction
        });

        _this2._buffer.input(changeCount);

        writer.setSelection(selection);

        _this2._buffer.unlock();
      });
    }
    /**
     * If the user keeps <kbd>Backspace</kbd> or <kbd>Delete</kbd> key pressed, the content of the current
     * editable will be cleared. However, this will not yet lead to resetting the remaining block to a paragraph
     * (which happens e.g. when the user does <kbd>Ctrl</kbd> + <kbd>A</kbd>, <kbd>Backspace</kbd>).
     *
     * But, if the user pressed the key in an empty editable for the first time,
     * we want to replace the entire content with a paragraph if:
     *
     * * the current limit element is empty,
     * * the paragraph is allowed in the limit element,
     * * the limit doesn't already have a paragraph inside.
     *
     * See https://github.com/ckeditor/ckeditor5-typing/issues/61.
     *
     * @private
     * @param {Number} sequence A number describing which subsequent delete event it is without the key being released.
     * @returns {Boolean}
     */

  }, {
    key: "_shouldEntireContentBeReplacedWithParagraph",
    value: function _shouldEntireContentBeReplacedWithParagraph(sequence) {
      // Does nothing if user pressed and held the "Backspace" or "Delete" key.
      if (sequence > 1) {
        return false;
      }

      var model = this.editor.model;
      var doc = model.document;
      var selection = doc.selection;
      var limitElement = model.schema.getLimitElement(selection); // If a collapsed selection contains the whole content it means that the content is empty
      // (from the user perspective).

      var limitElementIsEmpty = selection.isCollapsed && selection.containsEntireContent(limitElement);

      if (!limitElementIsEmpty) {
        return false;
      }

      if (!model.schema.checkChild(limitElement, 'paragraph')) {
        return false;
      }

      var limitElementFirstChild = limitElement.getChild(0); // Does nothing if the limit element already contains only a paragraph.
      // We ignore the case when paragraph might have some inline elements (<p><inlineWidget>[]</inlineWidget></p>)
      // because we don't support such cases yet and it's unclear whether inlineWidget shouldn't be a limit itself.

      if (limitElementFirstChild && limitElementFirstChild.name === 'paragraph') {
        return false;
      }

      return true;
    }
    /**
     * The entire content is replaced with the paragraph. Selection is moved inside the paragraph.
     *
     * @private
     * @param {module:engine/model/writer~Writer} writer The model writer.
     */

  }, {
    key: "_replaceEntireContentWithParagraph",
    value: function _replaceEntireContentWithParagraph(writer) {
      var model = this.editor.model;
      var doc = model.document;
      var selection = doc.selection;
      var limitElement = model.schema.getLimitElement(selection);
      var paragraph = writer.createElement('paragraph');
      writer.remove(writer.createRangeIn(limitElement));
      writer.insert(paragraph, limitElement);
      writer.setSelection(paragraph, 0);
    }
    /**
     * Checks if the selection is inside an empty element that is the first child of the limit element
     * and should be replaced with a paragraph.
     *
     * @private
     * @param {module:engine/model/selection~Selection} selection The selection.
     * @param {Number} sequence A number describing which subsequent delete event it is without the key being released.
     * @returns {Boolean}
     */

  }, {
    key: "_shouldReplaceFirstBlockWithParagraph",
    value: function _shouldReplaceFirstBlockWithParagraph(selection, sequence) {
      var model = this.editor.model; // Does nothing if user pressed and held the "Backspace" key or it was a "Delete" button.

      if (sequence > 1 || this.direction != 'backward') {
        return false;
      }

      if (!selection.isCollapsed) {
        return false;
      }

      var position = selection.getFirstPosition();
      var limitElement = model.schema.getLimitElement(position);
      var limitElementFirstChild = limitElement.getChild(0); // Only elements that are direct children of the limit element can be replaced.
      // Unwrapping from a block quote should be handled in a dedicated feature.

      if (position.parent != limitElementFirstChild) {
        return false;
      } // A block should be replaced only if it was empty.


      if (!selection.containsEntireContent(limitElementFirstChild)) {
        return false;
      } // Replace with a paragraph only if it's allowed there.


      if (!model.schema.checkChild(limitElement, 'paragraph')) {
        return false;
      } // Does nothing if the limit element already contains only a paragraph.


      if (limitElementFirstChild.name == 'paragraph') {
        return false;
      }

      return true;
    }
  }]);

  return DeleteCommand;
}(Command);

export { DeleteCommand as default };